module.exports = __webpack_public_path__ + "img/375w.7b3b3ae.jpg";